__turbopack_context__.v({
  "block_btn": "CardCalculator-module-scss-module__S4QRna__block_btn",
  "checkboxes": "CardCalculator-module-scss-module__S4QRna__checkboxes",
  "equalizer_chosedProgram": "CardCalculator-module-scss-module__S4QRna__equalizer_chosedProgram",
  "equalizer_dropdown": "CardCalculator-module-scss-module__S4QRna__equalizer_dropdown",
  "equalizer_program_active": "CardCalculator-module-scss-module__S4QRna__equalizer_program_active",
  "equalizer_programs": "CardCalculator-module-scss-module__S4QRna__equalizer_programs",
  "equalizer_programs_item": "CardCalculator-module-scss-module__S4QRna__equalizer_programs_item",
  "equalizer_svgArrows": "CardCalculator-module-scss-module__S4QRna__equalizer_svgArrows",
  "equalizer_svgRotate": "CardCalculator-module-scss-module__S4QRna__equalizer_svgRotate",
  "modal__left": "CardCalculator-module-scss-module__S4QRna__modal__left",
  "modal__text": "CardCalculator-module-scss-module__S4QRna__modal__text",
  "modal__text_grey": "CardCalculator-module-scss-module__S4QRna__modal__text_grey",
  "mortgageLink": "CardCalculator-module-scss-module__S4QRna__mortgageLink",
  "sliders": "CardCalculator-module-scss-module__S4QRna__sliders",
});
